<template>
  <div class="spin-box" :class="{ spinning: spinning }">
    <div>
      <span class="spin-dot">
        <i class="spin-dot-item"></i><i class="spin-dot-item"></i
        ><i class="spin-dot-item"></i><i class="spin-dot-item"></i>
      </span>
    </div>
    <section class="fixed-mask"></section>
  </div>
</template>

<script>
export default {
  name: "spin",
  props: {
    spinning: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.spin-box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  display: none;
  opacity: 0;
  width: 100%;
  height: 100%;
  &.spinning {
    // position: static;
    display: inline-block;
    opacity: 1;
  }
  .fixed-mask {
    background: rgba(255, 255, 255, 0.4);
  }
  .spin-dot {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -16px;
    display: inline-block;
    width: 1em;
    height: 1em;
    font-size: 32px;
    transform: rotate(0deg);
    animation: antRotate 1.2s infinite linear;
    z-index: 999999;
    &-item {
      position: absolute;
      display: block;
      width: 14px;
      height: 14px;
      background-color: #0044c1;
      border-radius: 100%;
      transform: scale(0.75);
      transform-origin: 50% 50%;
      opacity: 0.3;
      animation: antSpinMove 1s infinite linear alternate;
      &:nth-child(1) {
        top: 0;
        left: 0;
      }

      &:nth-child(2) {
        top: 0;
        right: 0;
        animation-delay: 0.4s;
      }

      &:nth-child(3) {
        right: 0;
        bottom: 0;
        animation-delay: 0.8s;
      }

      &:nth-child(4) {
        bottom: 0;
        left: 0;
        animation-delay: 1.2s;
      }
    }
  }
}
@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}

@keyframes antRotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
